/**
 * TransactionLog.card is a JSONField with THREE shapes in production data:
 *   - string: a provider card-token/source id (app topups)
 *   - { cardNumber: '...' }: legacy provider source dicts
 *   - { brand, masked_account_number, ... }: card-present terminal charges
 * Every renderer must go through this helper — string methods on the object
 * shapes crash the page (and vice versa).
 */
/** The description the backend writes on a POS card sale's directPay row
 *  (terminals/pos_sale.py finalize_pos_sale). */
export const CARD_SALE_DESCRIPTION = 'Card present sale'

/** A card charged on a reader at a booth (D135 or Tap to Pay). */
export function isCardSale(tx: { action?: string; description?: string | null }): boolean {
  return tx.action === 'directPay' && tx.description === CARD_SALE_DESCRIPTION
}

export function cardLabel(card: unknown): string | null {
  if (!card) return null
  if (typeof card === 'string') {
    if (card === 'CASH') return null
    if (card.length > 10) return `${card.slice(0, 8)}…`
    return `Ending in ${card.slice(-4)}`
  }
  if (typeof card === 'object') {
    const c = card as Record<string, unknown>
    const masked = typeof c.masked_account_number === 'string' ? c.masked_account_number : null
    const brand = typeof c.brand === 'string' ? c.brand : null
    if (masked) return [brand, masked].filter(Boolean).join(' ')
    const num = typeof c.cardNumber === 'string' ? c.cardNumber : null
    if (num) return `Ending in ${num.slice(-4)}`
    if (brand) return brand
  }
  return null
}
